import { requestListConstants } from '../containers/Requests/request-list.constants';
import createExcelFromRequestsArray from '../helpers/createExcelFromRequestsArray';

const url = '/Request';

export const exportActions = {
  exportRequests,
};

function exportRequests(list) {

  return (dispatch, getState) => {

    const { requests } = getState().requestsStore;

    createExcelFromRequestsArray(list, requests);

    dispatch({
      type: requestListConstants.EXPORT_END,
      payload: 0
    })

  }
}
